export function getQueryStringFromUrl(url: string) {
	const queryIndex = url.indexOf('?')
	if (queryIndex === -1) return ''
	return url.substring(queryIndex + 1)
}
